export * from "-!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../node_modules/framevuerk-builder/node_modules/pug-html-loader/lib/index.js!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/index.js??vue-loader-options!./fvSlider.vue?vue&type=template&id=5a50ce9a&lang=pug&"


//////////////////
// WEBPACK FOOTER
// ./src/components/fvSlider.vue?vue&type=template&id=5a50ce9a&lang=pug&
// module id = 163
// module chunks = 0 1